const React = require('react');
const { connect } = require('react-redux');
const { context } = require('../app-context');
const UserSearchFilterDialog = require('components/UserSearchFilterDialog');
const UserSearchFilterFormConfig = require('components/UserSearchFilterDialog/formConfig');
const SearchFilterApplicability = require('components/UserSearchFilterDialog/filterApplicability');
const { analyticsTemplates } = require('../utils/analytics');
const { USERS_SORT_TYPE } = require('../utils/constants');

const internals = {};
const selectors = context.selectors.all;
const actions = context.actions;

const SurveyUsersFilterDialog = (props) => <UserSearchFilterDialog
    {...props}
    fieldNames={UserSearchFilterFormConfig.ADMIN_FIELD_NAMES}
    includeContextFilterType={false}
    majorAsArray={false}
/>;

module.exports = connect(
    (state) => ({
        interests: selectors.getInterests(state),
        majors: selectors.getMajorsList_forCurrentUser(state),
        incomingClassList: selectors.getIncomingClassList_forCurrentUser(state),
        graduatingClassList: selectors.getGraduatingClassList_forCurrentUser(state),
        isParent: selectors.isParentPermission(state),
        currentUserPermissions: selectors.getCurrentUserRolePermissions(state),
        departments: selectors.getDepartmentsList_forProfileEditPage(state),
        yearsHiredList: selectors.getAllYearsHired(state),
        officesList: selectors.getAllOffices(state),
        isCompany: selectors.getSchoolIsCompany(state),
        isCommunity: selectors.getSchoolIsCommunity(state),
        isSchoolOnline: selectors.getSchoolIsOnline(state),
        canSearchHousing: selectors.getCanSearchHousing_forUserSearch(state),
        canSearchHometown: selectors.getCanSearchHometown_forUserSearch(state),
        schoolRoles: selectors.getSchoolUsedRoles(state),
        activeSearchFilter: selectors.getSurveySearchCriteria(state),
        roleGroupFilter: selectors.getRoleGroupFilter(state, 'admin'),
        badges: selectors.getAllBadges(state),
    }),
    {
        // eslint-disable-next-line hapi/no-arrowception
        onSubmit: (criteria, sortType = USERS_SORT_TYPE.ALPHABETICAL) => (dispatch, getState) => { // eslint-disable-line hapi/no-arrowception, hapi/hapi-scope-start

            const prunedCriteria = internals.pruneSearchCriteria(criteria, getState());
            const filteredCriteria = prunedCriteria ? internals.filterOutEmpty(prunedCriteria) : [];

            const searchKeys = prunedCriteria ? Object.keys(filteredCriteria) : [];

            // Default back to 'allByMatches: true' if 'includeStaff' is true
            if (searchKeys.length === 1 && filteredCriteria.includeStaff) {
                delete filteredCriteria.includeStaff;
            }

            analyticsTemplates.buttons('submit survey users search', `discover: search submit ${searchKeys.length ? searchKeys : 'empty'}`);

            if (searchKeys.length === 0) {
                return dispatch(actions.dataFetching.fetchUserSearchSurveyResults({
                    allByMatches: true,
                    sortType
                }));
            }

            const { interests, ...others } = filteredCriteria;

            const search = { ...others };

            if (interests) {
                search.interests = interests.map((x) => x.id);
            }

            return dispatch(actions.dataFetching.fetchUserSearchSurveyResults({
                ...search,
                sortType
            }));
        },
        // eslint-disable-next-line hapi/no-arrowception, hapi/hapi-scope-start
        resetSearch: (sortType, contextFilter) => (dispatch) => {

            dispatch(actions.app.setSurveySearchCriteria({ filter: {} }));
            dispatch(actions.app.setRoleGroupFilter({ admin: contextFilter || 'all' }));

            return dispatch(actions.dataFetching.fetchUserSearchSurveyResults({
                allByMatches: true,
                sortType: USERS_SORT_TYPE.ALPHABETICAL
            }));
        }
    }
)(SurveyUsersFilterDialog);

internals.filterOutEmpty = (obj) => {

    const { isBool } = internals;

    return Object.keys(obj).filter((key) => {

        const value = obj[key];

        if (Array.isArray(value)) {
            return !!value.length;
        }

        return isBool(value) || !!value;
    })
        .reduce((collector, key) => {

            collector[key] = obj[key];
            return collector;
        }, {});
};

internals.isBool = (maybeBool) => {

    if (String(maybeBool) === 'true' || String(maybeBool) === 'false') {
        return true;
    }

    return false;
};

internals.pruneSearchCriteria = (criteria, state) => SearchFilterApplicability.pruneForSelectedUserType(criteria, {
    allRoles: selectors.getRoles(state),
    availableRoleGroups: selectors.getSchoolUsedRoleGroups(state),
    badges: selectors.getAllBadges(state),
    canSearchHometown: selectors.getCanSearchHometown_forUserSearch(state),
    canSearchHousing: selectors.getCanSearchHousing_forUserSearch(state),
    currentUserPermissions: selectors.getCurrentUserRolePermissions(state),
    departments: selectors.getDepartmentsList_forProfileEditPage(state),
    fieldNames: SearchFilterApplicability.ADMIN_FIELD_NAMES,
    isCompany: selectors.getSchoolIsCompany(state),
    isCommunity: selectors.getSchoolIsCommunity(state),
    isSchoolOnline: selectors.getSchoolIsOnline(state),
    schoolRoles: selectors.getSchoolUsedRoles(state)
});
